import { render, staticRenderFns } from "./ProjectFlightDetails.vue?vue&type=template&id=67650488&"
import script from "./ProjectFlightDetails.vue?vue&type=script&lang=js&"
export * from "./ProjectFlightDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports